import { Pipe, PipeTransform } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import 'moment/locale/es';

moment.locale('es');

@Pipe({
  name: 'relativeDay'
})
export class RelativeDayPipe implements PipeTransform {

  /**
   * Devuelve la etiqueta de un día relativo al día de hoy.
   *
   * @param value Fecha seleccionada en el datepicker.
   * @param timeZone Offset en horas de la colonia (Neighborhood.timeZone).
   *                 Si no se envía, se usa el reloj del navegador.
   *
   * 0 -> Hoy | -1 -> Ayer | -2 -> Antier | 1 -> Mañana | 2 -> Pasado mañana
   * Otro día del año actual -> Lun 05 Oct
   * Otro día de un año distinto -> Lun 05 Oct 2025
   */
  transform(
    value: NgbDateStruct | undefined | null,
    timeZone?: number | null
  ): string {

    if (!value) return '';

    const selectedDay = moment.utc({
      year: value.year,
      month: value.month - 1,
      day: value.day
    });

    if (!selectedDay.isValid()) return '';

    const currentDay = timeZone === undefined || timeZone === null
      ? moment().startOf('day')
      : moment.utc().add(timeZone, 'hours').startOf('day');

    const differenceInDays = selectedDay.diff(currentDay, 'days');

    const relativeLabel = this.getRelativeLabel(differenceInDays);

    if (relativeLabel) return relativeLabel;

    const weekdayLabel = this.capitalizeFirstLetter(
      selectedDay.format('ddd').replace(/\./g, '')
    );

    const dateLabel = selectedDay.year() === currentDay.year()
      ? selectedDay.format('DD MMM')
      : selectedDay.format('DD MMM YYYY');

    return `${weekdayLabel} ${dateLabel}`;
  }

  private getRelativeLabel(
    differenceInDays: number
  ): string | undefined {

    switch (differenceInDays) {
      case 0: return 'Hoy';
      case -1: return 'Ayer';
      case -2: return 'Antier';
      case 1: return 'Mañana';
      case 2: return 'Pasado mañana';
      default: return undefined;
    }
  }

  private capitalizeFirstLetter(
    value: string
  ): string {

    return value.charAt(0).toUpperCase() + value.slice(1);
  }

}
